
import { Check } from "lucide-react";

interface FeatureItemProps {
  feature: React.ReactNode;
}

const FeatureItem = ({ feature }: FeatureItemProps) => {
  return (
    <li className="flex items-center gap-2 text-foreground">
      <Check className="h-4 w-4 text-primary flex-shrink-0" />
      <span className="text-sm">{feature}</span>
    </li>
  );
};

export default FeatureItem;
